(function($) {
	
	var filterSelect = $("#filter-select-search");
	var searchFilter = $.urlParam('searchfilter');
	var firstLoad = true;

	$(document).ready(function() {
		if(filterSelect.length && searchFilter && firstLoad) {
			$(filterSelect).val(searchFilter);
			$(filterSelect).trigger("change");
			firstLoad = false;
		}
	});
})(jQuery);
